import { render, staticRenderFns } from "./HistoriqueemailModule.vue?vue&type=template&id=4c5dff86"
import script from "./HistoriqueemailModule.vue?vue&type=script&lang=js"
export * from "./HistoriqueemailModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports